/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_ModelInputs */

const en_field_model = /** @type {(inputs: Field_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

const es_field_model = /** @type {(inputs: Field_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo`)
};

const fr_field_model = /** @type {(inputs: Field_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèle`)
};

const de_field_model = /** @type {(inputs: Field_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modell`)
};

const ja_field_model = /** @type {(inputs: Field_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モデル`)
};

const zh_field_model = /** @type {(inputs: Field_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`型号`)
};

const ar_field_model = /** @type {(inputs: Field_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموديل`)
};

const id_field_model = /** @type {(inputs: Field_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

const it_field_model = /** @type {(inputs: Field_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modello`)
};

const ru_field_model = /** @type {(inputs: Field_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Модель`)
};

const pt_field_model = /** @type {(inputs: Field_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo`)
};

const ko_field_model = /** @type {(inputs: Field_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모델`)
};

/**
* | output |
* | --- |
* | "Model" |
*
* @param {Field_ModelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_model = /** @type {((inputs?: Field_ModelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_ModelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_model(inputs)
	if (locale === "es") return es_field_model(inputs)
	if (locale === "fr") return fr_field_model(inputs)
	if (locale === "de") return de_field_model(inputs)
	if (locale === "ja") return ja_field_model(inputs)
	if (locale === "zh") return zh_field_model(inputs)
	if (locale === "ar") return ar_field_model(inputs)
	if (locale === "id") return id_field_model(inputs)
	if (locale === "it") return it_field_model(inputs)
	if (locale === "ru") return ru_field_model(inputs)
	if (locale === "pt") return pt_field_model(inputs)
	return ko_field_model(inputs)
});